import axios from "axios";
import AdminSlice from "./adminSlice";
import AdminApi from "./services/admin";


export const AdminActions = AdminSlice.actions

export const getPlacementList = () => {
    return async (dispatch:any) => {
        const response = await AdminApi.getPlacementsDetails()
        dispatch(AdminActions.setPlacements(response))
    }
}
export const getEvents = (type:string) => {
    return async (dispatch:any) => {
        const response = await AdminApi.getEventsList(type)
        dispatch(AdminActions.setEvents(response))
    }
}

